import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)


        this.gradient.addColorStop(0, 'rgba(33, 150, 243, 0.5)')
        this.gradient.addColorStop(0.5, 'rgba(33, 150, 243, 0.25)');
        this.gradient.addColorStop(1, 'rgba(33, 150, 243, 0)');
        
        const data = this.chartData;

        // Gradient only for filled area charts; unfilled lines keep their own colour.
        if (data.datasets[0] && data.datasets[0].fill !== false) {
            data.datasets[0].backgroundColor = this.gradient;
        }
      
        this.renderChart(data, this.options)
  }
}